exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.spinner_container_2gp3A {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n}\n\n.spinner_spinner_3_DJ6 {\n    font-size: 48px;\n    line-height: 1;\n}\n\n.spinner_spinner_3_DJ6:after {\n    content: \"\\2744\";\n    display: block;\n    color: var(--looks-secondary);\n    animation: spinner_snow-up_E3im6 1.4s ease-in-out infinite alternate;\n}\n\n.spinner_innerVisible_2fXlP {\n    display: block;\n    font-size: 48px;\n    color: #FFFFFF;\n    animation: spinner_snow-up_E3im6 1.4s ease-in-out infinite alternate;\n}\n\n@keyframes spinner_snow-up_E3im6 {\n    0% { transform: translateY(20px) scale(0.7); opacity: 0; }\n    60% { transform: translateY(0px) scale(1.0); opacity: 1; }\n    100% { transform: translateY(-6px) scale(0.95); opacity: 0.6; }\n}\n", ""]);

// exports
exports.locals = {
	"container": "spinner_container_2gp3A",
	"spinner": "spinner_spinner_3_DJ6",
	"snow-up": "spinner_snow-up_E3im6",
	"snowUp": "spinner_snow-up_E3im6",
	"innerVisible": "spinner_innerVisible_2fXlP"
};